// extracted by mini-css-extract-plugin
export var img = "MaterialPreview-module--img--SfhmM";
export var pdf = "MaterialPreview-module--pdf--YZbR1";